export interface DeferredOnboardingReturn {
  pathname: string;
  search?: string;
  state?: unknown;
}

export const ONBOARDING_DEFERRED_RETURN_KEY = 'booka_onboarding_deferred_return';

export const saveDeferredOnboardingReturn = (value: DeferredOnboardingReturn) => {
  try {
    sessionStorage.setItem(ONBOARDING_DEFERRED_RETURN_KEY, JSON.stringify(value));
  } catch {
    // A missing/blocked sessionStorage must not prevent onboarding.
  }
};

export const getDeferredOnboardingReturn = (): DeferredOnboardingReturn | null => {
  try {
    const raw = sessionStorage.getItem(ONBOARDING_DEFERRED_RETURN_KEY);
    if (!raw) return null;
    const value = JSON.parse(raw) as DeferredOnboardingReturn;
    if (!value?.pathname?.startsWith('/onboarding/')) return null;
    return value;
  } catch {
    return null;
  }
};

export const clearDeferredOnboardingReturn = () => {
  try {
    sessionStorage.removeItem(ONBOARDING_DEFERRED_RETURN_KEY);
  } catch {
    // Storage may be unavailable in restricted web contexts.
  }
};

export const getDeferredOnboardingUrl = (value: DeferredOnboardingReturn) =>
  `${value.pathname}${value.search || ''}`;
